import { Component, input } from '@angular/core';

@Component({
  selector: 'app-loader-overlay',
  templateUrl: './loader-overlay.component.html',
  styleUrl: './loader-overlay.component.scss',
  standalone: false,
})
export class LoaderOverlayComponent {
  active = input(false);
}
